{
  "$comment": [
    "User-facing changes to Ronin, newest first. Rendered at /nyheter (Swedish) and /en/news (English).",
    "Add a new entry at the TOP of entries, never at the bottom. The render sorts by date,",
    "so an appended entry looks right on the site and only this file ends up out of order.",
    "Every user-facing Ronin change gets an entry here in the same commit as the change - see CLAUDE.md.",
    "Fields: date = when the change landed in the repo (YYYY-MM-DD).",
    "version = the ronin-v tag it shipped in, e.g. \"1.0.8\", or null while it is still unreleased.",
    "Stamp version when the tag is cut (the release skill does this). Never guess a future version.",
    "title and description carry both languages as { \"sv\": ..., \"en\": ... }. Short sentences,",
    "second person, no em-dashes, and never a word about what a value means.",
    "area = \"app\" or \"web\"; web entries get no version pill because the site deploys on merge."
  ],
  "entries": [
    {
      "date": "2026-10-23",
      "version": null,
      "area": "web",
      "title": {
        "sv": "Ronin finns i App Store och Google Play",
        "en": "Ronin is in the App Store and on Google Play"
      },
      "description": {
        "sv": "Knapparna på startsidan går nu direkt till appen i butikerna. Appen är gratis och har inget konto.",
        "en": "The buttons on the home page now go straight to the app in the stores. The app is free and has no account."
      }
    },
    {
      "date": "2026-09-06",
      "version": "1.0.9",
      "area": "app",
      "title": {
        "sv": "Fyra små widgetar på iPhone",
        "en": "Four small widgets on iPhone"
      },
      "description": {
        "sv": "Förut kunde den lilla widgeten bara öppna blodsocker. Nu finns en liten widget per typ: blodsocker, kolhydrater, anteckning och insulin. Lägg två bredvid varandra, eller en på låsskärmen.",
        "en": "The small widget could only open glucose. Now there is one small widget per type: glucose, carbs, note and insulin. Put two side by side, or one on the Lock Screen."
      }
    },
    {
      "date": "2026-09-06",
      "version": "1.0.9",
      "area": "app",
      "title": {
        "sv": "Samma ordning överallt",
        "en": "The same order everywhere"
      },
      "description": {
        "sv": "Knapparna kommer nu i ordningen blodsocker, kolhydrater, anteckning, insulin, och ketoner sist om du slagit på dem. Det gäller raden på Idag, widgetarna, snabbvalen på appikonen och klockan. Snabbvalen följer nu också språket du valt i appen.",
        "en": "The buttons now come in the order glucose, carbs, note, insulin, with ketones last if you have switched them on. That goes for the row on Today, the widgets, the shortcuts on the app icon and the watch. The shortcuts now also follow the language you chose in the app."
      }
    },
    {
      "date": "2026-09-05",
      "version": "1.0.9",
      "area": "app",
      "title": {
        "sv": "Ronin på Apple Watch",
        "en": "Ronin on Apple Watch"
      },
      "description": {
        "sv": "Samma fyra knappar på handleden. Du skriver in värdet på klockan och det hamnar i dagboken i telefonen. Klockan sparar bara det som inte nått telefonen än, aldrig dagboken, och visar inga värden.",
        "en": "The same four buttons on your wrist. You type the value on the watch and it lands in the diary on your phone. The watch keeps only what has not reached the phone yet, never the diary, and shows no values."
      }
    },
    {
      "date": "2026-09-05",
      "version": "1.0.9",
      "area": "app",
      "title": {
        "sv": "Widgeten på iPhone visar riktiga ord",
        "en": "The iPhone widget shows real words"
      },
      "description": {
        "sv": "I förra versionen kunde widgeten visa koder i stället för ord. Nu står det Blodsocker, Kolhydrater, Anteckning och Insulin, på svenska eller engelska efter telefonens språk.",
        "en": "In the last version the widget could show codes instead of words. Now it reads Glucose, Carbs, Note and Insulin, in Swedish or English after your phone's language."
      }
    },
    {
      "date": "2026-09-04",
      "version": "1.0.9",
      "area": "app",
      "title": {
        "sv": "Språkbytet stänger inte längre appen",
        "en": "Switching language no longer closes the app"
      },
      "description": {
        "sv": "Att byta språk två gånger i rad kunde stänga appen. Det är rättat.",
        "en": "Switching language twice in a row could close the app. Fixed."
      }
    },
    {
      "date": "2026-09-04",
      "version": "1.0.9",
      "area": "app",
      "title": {
        "sv": "Logga från hemskärmen",
        "en": "Log from the home screen"
      },
      "description": {
        "sv": "Android: en widget med fyra knappar, och snabbval när du håller in appikonen. iPhone: snabbval på appikonen och en widget för hemskärmen och låsskärmen. Ett tryck öppnar appen med rätt inmatning redo. Widgeten visar aldrig något värde.",
        "en": "Android: a widget with four buttons, and shortcuts when you press and hold the app icon. iPhone: shortcuts on the app icon and a widget for the Home Screen and the Lock Screen. One tap opens the app with the right entry ready. The widget never shows a value."
      }
    },
    {
      "date": "2026-09-04",
      "version": "1.0.9",
      "area": "app",
      "title": {
        "sv": "Tagga ett inlägg",
        "en": "Tag an entry"
      },
      "description": {
        "sv": "Märk ett inlägg med träning, sjuk, alkohol, resa, stress eller annat. I Historik kan du visa bara inläggen med en viss tagg, och taggarna följer med i CSV-exporten.",
        "en": "Mark an entry with exercise, illness, alcohol, travel, stress or other. In History you can show only the entries with one tag, and the tags come along in the CSV export."
      }
    }
  ]
}
